<template>
    <div class="page-index">
        <div class="page-content">
            <header class="page-header">
                <div class="page-header-logo">
                    <img
                        src="@/assets/images/business_and_food_lovers_club.svg"
                        alt="Business & Food Lovers Club"
                    />
                </div>
                <div class="page-header-image" />
            </header>
            <div class="page-index-body">
                <CampaignIntro />
            </div>

            <img
                class="footer-logo"
                src="~@/assets/images/corner_logo.svg"
                alt="Makro - Twój sukces to nasz biznes"
            />
        </div>
        <CampaignBackground />
    </div>
</template>

<script>
import CampaignBackground from '@/components/page/campaign/CampaignBackground'
import CampaignIntro from '@/components/page/campaign/CampaignIntro'
import gtmHit from '@/gtm'
import { mapGetters } from 'vuex'

export default {
    name: 'index',
    components: {
        CampaignIntro,
        CampaignBackground
    },
    computed: {
        ...mapGetters({
            cookiesTypes: 'getCookiesTypes'
        }),
        cookiesAdvertisingAllowed() {
            return this.cookiesTypes && this.cookiesTypes.advertising
        }
    },
    mounted () {
        if (this.cookiesAdvertisingAllowed) {
            gtmHit(this, {
                url: this.$route.fullPath,
                templateType: 'homepage',
                seoTitle: `Makro rejestracja`
            })
        }

        this.$nextTick(() => {
            setTimeout(() => {
                this.$store.commit('setLoading', false)
            }, 800)
        })
    },
    methods: {
    }
}
</script>

<style lang="scss">
    // @import "../assets/scss/style";
    @import "src/assets/scss/_variables/screen";

    .page-index {
        .page-content {
            max-width: 960px;
            overflow: hidden;
        }

        &-body {
            padding: 0 28px 102px;


        }

        .footer-logo {
            position: absolute;
            bottom: -2px;
            right: -5px;
        }

        @media (max-width: 960px) {
            .page-content {
                padding: 0 50px 60px;
            }
        }
        @media (max-width: $screen-small-tablet) {
            .page-content {
                padding: 0 0 60px;
            }
        }
    }

</style>
